import {Injectable} from '@angular/core';
import {Http, Response, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import { SharedService } from '../../shared/shared.service';

import { environment } from '../../../environments/environment';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable ()

export class ReportService {
  public baseUrl: string;
  public dataForm: any;

  constructor(
      private _http: Http,
      private _data: SharedService,
    ) {
    this.baseUrl = environment.apiUrl;
  }

  getReportData(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    return this._http.post(this.baseUrl + 'report', json, {headers: headers}).map(res => res.json());
  }

  getReportTabla(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    console.log('ruta', this.baseUrl + 'report');
    return this._http.post(this.baseUrl + 'reportTabla', json, {headers: headers}).map(res => res.json());
  }

  exportAsExcelFile(json: any[], excelFileName: string): void {
    
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet',worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  getRoomMsgs(data: any) {   
    let json = JSON.stringify(data.user_id);
    let user_id = data.user_id != null ? '?user_id='+data.user_id : '';
    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    //console.log("Data: ", data);
    //console.log("Esto es lo que se le envía: ", JSON.stringify(data));
    //return this._http.get(this.baseUrl + 'room/' + this.id_room + '/messages'+ user_id, {headers: headers}).map(res => res.json());
    return this._http.get(this.baseUrl + 'room/' + data.room_id + '/messages'+ user_id, {headers: headers}).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/report/report.service.ts